import { useTheme } from 'ui';
import type { ComponentProps } from 'react';
import { forwardRef } from 'react';
import { TextField as TextFieldMUI } from 'vendor/material';
import { InputLabel } from './InputLabel';

type TextFieldProps = ComponentProps<typeof TextFieldMUI> & {
  dataId?: string;
  label?: string;
  name: string;
  errorMessage?: string;
};

/**
 * TextField component that wraps Material-UI's TextField with additional props
 * replacing the TextInputField which is built on top of the platform-ui TextField that does
 * not support passing refs well.
 */
const TextField = forwardRef(
  (
    {
      dataId,
      errorMessage,
      name,
      label,
      required,
      ...fieldProps
    }: TextFieldProps,
    ref,
  ) => {
    const theme = useTheme();

    return (
      <div style={{ display: 'grid', gap: '4px' }}>
        <InputLabel
          data-id={dataId ? `${dataId}-label` : undefined}
          name={name}
          label={label}
          required={required}
        />
        <TextFieldMUI
          data-id={dataId}
          inputRef={ref}
          {...fieldProps}
          helperText={errorMessage ?? fieldProps.helperText}
          id={name}
          name={name}
          variant="outlined"
          size="small"
          InputProps={{
            style: {
              fontSize: theme.typography.pxToRem(14),
              fontWeight: 600,
            },
          }}
          fullWidth
        />
      </div>
    );
  },
);
export default TextField;
